/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Columns_PathInputs */

const id_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalur file`)
};

const ms_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Laluan fail`)
};

const da_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filsti`)
};

const de_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateipfad`)
};

const en_us2_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`File path`)
};

const es_es2_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruta del archivo`)
};

const es_mx2_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruta del archivo`)
};

const fil_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Path ng file`)
};

const fr_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chemin du fichier`)
};

const it_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Percorso del file`)
};

const hu_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fájlútvonal`)
};

const nl_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestandspad`)
};

const no_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filbane`)
};

const pl_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ścieżka pliku`)
};

const pt_br2_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caminho do arquivo`)
};

const pt_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caminho do ficheiro`)
};

const ro_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calea fișierului`)
};

const fi_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiedostopolku`)
};

const sv_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filsökväg`)
};

const vi_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đường dẫn tệp`)
};

const tr_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosya yolu`)
};

const cs_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cesta k souboru`)
};

const bg_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Път на файла`)
};

const ru_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Путь к файлу`)
};

const uk_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Шлях до файлу`)
};

const ar_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مسار الملف`)
};

const hi_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़ाइल पाथ`)
};

const th_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เส้นทางไฟล์`)
};

const ja_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ファイルパス`)
};

const zh_cn2_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文件路径`)
};

const zh_hant1_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`檔案路徑`)
};

const ko_builds_comparison_columns_path = /** @type {(inputs: Builds_Comparison_Columns_PathInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`파일 경로`)
};

/**
* | output |
* | --- |
* | "File path" |
*
* @param {Builds_Comparison_Columns_PathInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_columns_path = /** @type {((inputs?: Builds_Comparison_Columns_PathInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Columns_PathInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_columns_path(inputs)
	if (locale === "ms") return ms_builds_comparison_columns_path(inputs)
	if (locale === "da") return da_builds_comparison_columns_path(inputs)
	if (locale === "de") return de_builds_comparison_columns_path(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_columns_path(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_columns_path(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_columns_path(inputs)
	if (locale === "fil") return fil_builds_comparison_columns_path(inputs)
	if (locale === "fr") return fr_builds_comparison_columns_path(inputs)
	if (locale === "it") return it_builds_comparison_columns_path(inputs)
	if (locale === "hu") return hu_builds_comparison_columns_path(inputs)
	if (locale === "nl") return nl_builds_comparison_columns_path(inputs)
	if (locale === "no") return no_builds_comparison_columns_path(inputs)
	if (locale === "pl") return pl_builds_comparison_columns_path(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_columns_path(inputs)
	if (locale === "pt") return pt_builds_comparison_columns_path(inputs)
	if (locale === "ro") return ro_builds_comparison_columns_path(inputs)
	if (locale === "fi") return fi_builds_comparison_columns_path(inputs)
	if (locale === "sv") return sv_builds_comparison_columns_path(inputs)
	if (locale === "vi") return vi_builds_comparison_columns_path(inputs)
	if (locale === "tr") return tr_builds_comparison_columns_path(inputs)
	if (locale === "cs") return cs_builds_comparison_columns_path(inputs)
	if (locale === "bg") return bg_builds_comparison_columns_path(inputs)
	if (locale === "ru") return ru_builds_comparison_columns_path(inputs)
	if (locale === "uk") return uk_builds_comparison_columns_path(inputs)
	if (locale === "ar") return ar_builds_comparison_columns_path(inputs)
	if (locale === "hi") return hi_builds_comparison_columns_path(inputs)
	if (locale === "th") return th_builds_comparison_columns_path(inputs)
	if (locale === "ja") return ja_builds_comparison_columns_path(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_columns_path(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_columns_path(inputs)
	return ko_builds_comparison_columns_path(inputs)
});
export { builds_comparison_columns_path as "builds.comparison.columns.path" }